import { createPortal } from "react-dom";

const Portal = ({el, children}) => {
  const element = el ? document.getElementById(el) : document.body;

  return createPortal(children, element)
};

export default Portal;